import { Stack, Typography, useTheme } from "@mui/material";
import { TriangleAlert } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const SoftWarning: FC = () => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack direction="row" gap={0.8} alignItems="flex-start" mt={0.8}>
			<TriangleAlert
				size={theme.iconSize.sm}
				color={theme.palette.amber.main}
				style={{ flexShrink: 0 }}
			/>
			<Typography variant="hint" color={theme.palette.amber.dark}>
				{t(Resources.Inspiration.softWarning)}
			</Typography>
		</Stack>
	);
};
